import { render, staticRenderFns } from "./AsACoachCheckpointInspectionCard.vue?vue&type=template&id=2652b99a"
import script from "./AsACoachCheckpointInspectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachCheckpointInspectionCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachCheckpointInspectionCard.vue?vue&type=style&index=0&id=2652b99a&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports